import React, { ReactElement } from 'react';

type HomeSideBarProps = {
    children?: React.ReactNode;
    open?: boolean;
    onClose?: () => void;
}

const HomeSideBar: React.FC<HomeSideBarProps> = ({ children, open = false, onClose }: HomeSideBarProps): ReactElement => {
    return (
        <div className={`overflow-hidden z-10 transition-transform transform duration-300 absolute bottom-0 left-0 top-0 ${open ? 'translate-x-0' : '-translate-x-full'} right-0`} onClick={onClose}>
            <div className={`z-10 ease-in-out overflow-hidden duration-200 transition-opacity absolute bottom-0 left-0 top-0 ${open ? 'delay-300 opacity-100' : 'opacity-0 delay-0'} right-0 bg-black bg-opacity-70`}>
                &bnsp;
            </div>
            <div className={`z-20 bg-white max-w-full w-72 absolute bottom-0 left-0 top-0 overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export default HomeSideBar;
